<template>
  <div class="app-container">
    <div class="recordermanagementBody">
      <el-col>
        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <div style="flex-direction: column; width: fit-content">
            设备IMEI：
            <el-input
              v-model="queryByNo"
              placeholder="请输入设备IMEI编号"
              style="width: 200px; margin-right: 10px"
            ></el-input>
            <el-button type="primary" @click="queryByNoEvent()">查询</el-button>
            <el-button @click="queryByNoEventReset()">重置</el-button>
          </div>

          <div>
            <el-button
              type="primary"
              @click="addWorkCamreaDialogVisibleFlag = true"
              >新增记录仪</el-button
            >
            <el-button type="primary" @click="cameraDownload()">导出</el-button>
          </div>
        </div>

        <div class="tableContainer">
          <el-table
            v-loading="listLoading"
            :data="dataList"
            border
            fit
            highlight-current-row
          >
            <el-table-column
              label="序号"
              type="index"
              align="center"
              width="50"
            >
            </el-table-column>
            <el-table-column
              label="设备品牌"
              prop="cameraBrand"
              width="200"
              align="center"
            />
            <el-table-column
              label="设备名称"
              prop="cameraName"
              width="200"
              align="center"
            />
            <el-table-column
              label="设备IMEI"
              prop="cameraNo"
              width="200"
              align="center"
            />
            <el-table-column
              label="当前状态"
              prop="status"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.status === 0 ? 'info' : 'success'"
                  class="change-state"
                  @click=""
                >
                  {{ statusTag[scope.row.status] }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="使用人"
              prop="useName"
              width="100"
              align="center"
            />

            <el-table-column
              label="操作"
              prop="tpye"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <!--                <el-button type="text" size="small" @click="">查看位置</el-button>-->

                <el-button
                  type="text"
                  size="small"
                  style="color: #f56c6c"
                  @click="delWorkCameraEvent(scope.row)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!--页码-->
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryForm.current"
            :limit.sync="queryForm.size"
            @pagination="queryCameraPage"
          />
        </div>
      </el-col>

      <el-dialog
        title="新增记录仪"
        :visible.sync="addWorkCamreaDialogVisibleFlag"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form label-width="120px">
          <el-form-item label="设备名称">
            <el-input
              v-model="cameraName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="设备IMEI">
            <el-input
              v-model="workCameraID"
              placeholder="请输入设备IMEI编号"
            ></el-input>
          </el-form-item>

          <el-form-item label="设备品牌">
            <el-select
              v-model="workCameraBrand"
              placeholder="请选择设备品牌"
              style="width: 100%"
            >
              <el-option
                v-for="item in this.cameraBrandList"
                :key="item.dictValue"
                :label="item.dictName"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!--          <el-form-item label="设备密码">-->
          <!--            <el-input v-model="workCameraPwd" placeholder="请输入设备密码"></el-input>-->
          <!--          </el-form-item>-->

          <el-form-item label="使用人">
            <div style="display: flex; flex-direction: row">
              <el-button @click="addPeople()">选择使用人</el-button>
              <div v-if="selectPeopleList.length > 0" style="margin-left: 10px">
                {{ this.selectPeopleList[0].id }}-{{
                  this.selectPeopleList[0].name
                }}
              </div>
            </div>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addWorkCamera()">确 定</el-button>
        </div>
      </el-dialog>

      <!--删除弹窗-->
      <el-dialog
        title="删除"
        :visible.sync="delWorkCameraDialogVisibleFlag"
        width="30%"
      >
        <span>确定删除该设备吗？</span>
        <div style="display: flex; flex-direction: column">
          <span>设备编号： {{ delWorkCamera.cameraNo }} </span>
          <span>设备品牌： {{ delWorkCamera.cameraBrand }} </span>
          <span>使用人： {{ delWorkCamera.useName }} </span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="delWorkCameraSubmit()"
            >确 定</el-button
          >
          <el-button @click="delWorkCameraDialogVisibleFlag = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>
    </div>

    <add-people
      :addPeopleVisible="addPeopleVisible"
      :dialogTitle="dialogTitle"
      :peopleList="selectPeopleList"
      :isLimit="true"
      @closeAddPeopleVisible="closeAddPeople"
      @submitPeople="submitPeople"
    ></add-people>
  </div>
</template>

<style>
.recordermanagementBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
<script>
import AddPeople from '@/components/AddPeople/index.vue';
import {
  cameraDelete,
  cameraDownload,
  cameraSave,
  getDictList,
  queryCameraPage,
} from '@/api/equipmentmanagement';
import Pagination from '@/components/PaginationStyle1.vue';
import { getCurrentFormattedDateTime } from '@/utils/TimeUtils';

export default {
  components: { Pagination, AddPeople },
  data() {
    return {
      cameraBrandList: [],

      queryByNo: '',

      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        size: 10,
        current: 1,
      },
      statusTag: ['离线', '在线'],

      addWorkCamreaDialogVisibleFlag: false,

      dialogTitle: '',
      addPeopleVisible: false,
      selectPeopleList: [],
      cameraName: '',
      workCameraID: '',
      workCameraBrand: '',
      // workCameraPwd:"",

      delWorkCameraDialogVisibleFlag: false,
      delWorkCamera: {},
    };
  },
  methods: {
    async getDictList() {
      const result = await getDictList({ dictCode: 'camera_brand' });
      this.cameraBrandList = result.data.data;
    },
    async queryCameraPage() {
      this.listLoading = true;
      const res = await queryCameraPage(this.queryForm);
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },
    addPeople() {
      this.addPeopleVisible = true;
      this.dialogTitle = '选择使用人';
    },
    closeAddPeople() {
      this.addPeopleVisible = false;
    },
    submitPeople(employeeRoleList) {
      // console.log(employeeRoleList)
      this.selectPeopleList = employeeRoleList;
    },
    async addWorkCamera() {
      if (this.cameraName === '') {
        this.$message.error('请输入设备名称');
        return;
      }
      if (this.workCameraID === '') {
        this.$message.error('请输入设备IMEI编号');
        return;
      }
      if (this.workCameraBrand === '') {
        this.$message.error('请选择设备品牌');
        return;
      }
      // if(this.workCameraPwd===''){
      //   this.$message.error("请输入设备密码");
      //   return
      // }
      if (this.selectPeopleList.length <= 0) {
        this.$message.error('请选择使用人');
        return;
      }

      let req = {
        cameraName: this.cameraName,
        cameraNo: this.workCameraID,
        cameraBrand: this.workCameraBrand,
        // "cameraPassword": this.workCameraPwd,
        useId: this.selectPeopleList[0].id,
        useName: this.selectPeopleList[0].name,
      };

      // console.log(req)
      const result = await cameraSave(req);

      if (result.data.code === 200) {
        this.$message({ message: '添加成功', type: 'success' });

        this.addWorkCamreaDialogVisibleFlag = false;

        //添加后刷新
        this.queryCameraPage();
      } else {
        this.$message.error(result.data.message);
      }
    },

    //删除
    delWorkCameraEvent(obj) {
      this.delWorkCameraDialogVisibleFlag = true;
      this.delWorkCamera = obj;
    },
    //删除记录仪
    async delWorkCameraSubmit() {
      let req = { id: this.delWorkCamera.id };

      const result = await cameraDelete(req);

      if (result.data.code === 200) {
        this.$message({ message: '删除成功', type: 'success' });

        this.delWorkCameraDialogVisibleFlag = false;

        //添加后刷新
        this.queryCameraPage();
      } else {
        this.$message.error(result.data.message);
      }
    },
    //下载表
    async cameraDownload() {
      try {
        const result = await cameraDownload();
        // 从响应中获取 Blob 对象
        const blob = result.data;

        // 创建一个 URL 对象
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        let fileName = '记录仪列表' + getCurrentFormattedDateTime() + '.xlsx';
        link.setAttribute('download', fileName); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        // 释放 URL 对象
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download error:', error);
      }
    },
    queryByNoEventReset() {
      this.queryByNo = '';
      this.queryForm.current = 1;
      this.queryForm.size = 10;
      this.queryCameraPage();
    },
    async queryByNoEvent() {
      this.listLoading = true;

      let onceSearch = {
        cameraNo: this.queryByNo,
        current: 1,
        size: 100,
      };

      const res = await queryCameraPage(onceSearch);
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },
  },
  created() {
    this.getDictList();

    this.queryCameraPage();
  },
};
</script>
